
import GbIcon from '../../../../components/Icon/Icon.vue'

export default {
  name: 'EventCardTags',
  components: { GbIcon },
  props: {
    event: {
      type: Object,
      required: true
    },

    isInBottomSheet: {
      type: Boolean,
      required: true
    },

    isTooltip: {
      type: Boolean,
      required: true
    },

    isHoliday: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    tagTextSize() {
      return this.isInBottomSheet ? 'body-5' : 'body-6'
    },

    isUserTeacher() {
      return this.event?.userRole === 'teacher'
    },

    isEventHomework() {
      return this.event?.type?.slug === 'homework'
    },

    tags() {
      if (this.isHoliday) {
        return [{ type: 'holiday', icon: 'dot', text: 'Каникулы' }]
      }

      const tags = []

      if (this.event?.type?.title) {
        tags.push({ type: 'default', icon: '#', text: this.event?.type?.title })
      }

      if (this.event?.type?.slug === 'event') {
        tags.push({ type: 'recommend', icon: '\u{1F4A5}', text: 'Рекомендуем' })
      }

      if (this.isUserTeacher) {
        tags.push({ type: 'teacher', icon: 'teacher', text: 'Вы преподаёте' })
      }

      if (this.isEventHomework) {
        for (const [key, value] of Object.entries(this.event?.tags)) {
          tags.push({ type: key, icon: '#', text: value })
        }
      }

      return tags.reverse()
    }
  }
}
